import { Avatar, Col, Icon, P4PDayFanGiftModal, P4PDayGiftBadge, Row, Text } from 'components';
import { getRoleBgColor } from 'core';
import { Api, getP4PDayTeamUsername, theme } from 'lib';
import { useSubscriptionStatus } from '../../../../hooks';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Bio, FollowingFollowers, Interactions, Sports, SubSettings } from './components';

const Header = ({
  isLoggedIn,
  user,
  currentUser,
  isCurrentUser,
  updateOtherUser,
  setIsCTAModalVisible,
  setIsSkipToSignUp,
  setActionType,
  onHandleClosePaymentAndCTAModals,
  onShoutoutPosted
}) => {
  // const [showSports, setShowSports] = useState(!isCurrentUser),
  //   [showAthletes, setShowAthletes] = useState(false),
  const [subSettingsVisible, setSubSettingsVisible] = useState(false),
    [p4pDayGiftVisible, setP4PDayGiftVisible] = useState(false),
    isMobile = useSelector((state) => state.appState.isMobile),
    { t } = useTranslation(),
    dispatch = useDispatch(),
    navigate = useNavigate(),
    [hasSubscriptionPlans, setHasSubscriptionPlans] = useState(false),
    following = currentUser?.following.includes(user._id),
    playedSports = user.sports?.filter((x) => x.sport !== ''),
    isFan = user.type === 'fan',
    isTeam = user.type === 'team',
    teamId = user?.teamId || user?._id,
    isVerified =
      user.type === 'athlete' &&
      ['verified', 'verifiedAndDismissed'].includes(user.verified?.idProgress);

  const isSubscribed = useSubscriptionStatus(isLoggedIn && isTeam, teamId);

  /*
    Whether THIS channel is the P4P Day team's.

    The badge is the fan's, but it is a badge for one sponsor's campaign, so it belongs on that
    sponsor's channel and on no other team's. Resolved from the campaign itself rather than from
    REACT_APP_DEFAULT_TEAM_USERNAME — the server matched that same value to the team it enrolled
    and auto-followed fans to, and if the two ever drift the env var would put the badge beside
    a team the campaign never touched, with nothing to signal it.

    Case-insensitive, because the backend resolves the team with a strength-2 collation and this
    has to agree with what it did.
  */
  const [isP4PDayTeam, setIsP4PDayTeam] = useState(false);

  useEffect(() => {
    if (!isTeam || !user?.username) {
      setIsP4PDayTeam(false);
      return undefined;
    }

    let active = true;
    getP4PDayTeamUsername().then((teamUsername) => {
      if (!active) return;
      setIsP4PDayTeam(!!teamUsername && teamUsername.toLowerCase() === user.username.toLowerCase());
    });

    return () => {
      active = false;
    };
  }, [isTeam, user?.username]);

  async function follow() {
    if (!isLoggedIn) {
      setIsCTAModalVisible(true);
      setIsSkipToSignUp(true);
      setActionType('follow');
      return;
    }

    if (following) return;

    const res = await Api.post('/users/follow', { userId: user._id }, 'follow');
    if (!res) return;

    dispatch({
      type: 'FOLLOW',
      payload: user._id
    });

    updateOtherUser({
      ...user,
      followersCount: user.followersCount + 1
    });

    onHandleClosePaymentAndCTAModals();
  }

  async function subscribe() {
    if (!isLoggedIn) {
      setIsCTAModalVisible(true);
      setIsSkipToSignUp(true);
      setActionType('subscribe');
      return;
    }

    navigate(`/subscription-plans?teamId=${user._id}`);
  }

  function unsubscribe() {
    if (user.type !== 'fan' && isSubscribed) {
      setSubSettingsVisible(true);
    }
  }

  useEffect(() => {
    if (isCurrentUser || isFan || !isTeam) return;

    let cancelled = false;

    async function fetchSubscriptionPlans() {
      const res = await Api.get(`/subscriptionPlans/byTeam?teamId=${user._id}`);
      if (!res || cancelled) return;

      setHasSubscriptionPlans(res.data.plans?.length > 0);
    }

    fetchSubscriptionPlans();

    return () => {
      cancelled = true;
    };
  }, [user._id, isCurrentUser, isFan]);

  async function unfollow() {
    const res = await Api.post('/users/unfollow', { userId: user._id }, 'follow');
    if (!res) return;

    dispatch({
      type: 'UNFOLLOW',
      payload: user._id
    });

    updateOtherUser({
      ...user,
      followersCount: user.followersCount - 1
    });

    onHandleClosePaymentAndCTAModals();
  }

  // function handleTriggerFace2Face(){
  //   if (!isLoggedIn) {
  //     setIsCTAModalVisible(true);
  //     setIsSkipToSignUp(true);
  //     setActionType('face2face');
  //   }

  //   return isLoggedIn;
  // }

  function handleShoutout() {
    if (!isLoggedIn) {
      setIsCTAModalVisible(true);
      setIsSkipToSignUp(true);
      setActionType('requestShoutout');
      return false;
    }

    return true; // needed to call the modal for shoutout
  }

  function handleGetApp() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: true
      }
    });
  }

  // if (isMobile) {
  //   return (
  //     <Col wid='100%' pad='24px'>
  //       <Row marg='0 0 24px'>
  //         <Avatar user={user} showVerified />

  //         <Col center marg='0 0 0 16px'>
  //           <Text h1={!isMobile} h4={isMobile} col={isMobile ? '#fff' : '#000'}>
  //             {user.name}
  //           </Text>

  //           <Row center start>
  //             <Text c1 med col={isMobile ? '#fff' : '#000'}>
  //               @{user.username}
  //             </Text>

  //             {isVerified && (
  //               <Row marg='0 0 0 6px' center>
  //                 <Icon type='verified' col={theme.PURPLE} dimensions={18} />

  //                 <Text c1 med col='#fff' marg='0 0 0 4px'>
  //                   {t('profile.verifiedAthlete')}
  //                 </Text>
  //               </Row>
  //             )}
  //           </Row>

  //           <FollowingFollowers user={user} isCurrentUser={isCurrentUser} />
  //         </Col>
  //       </Row>

  //       <Col wid='100%' gap='24px'>
  //         <Row wid='100%' between>
  //           {/* display when viewing other user and when logged in ------------ */}
  //           {!isCurrentUser && currentUser && (
  //             <Row center pad='0 16px 0 0'>
  //               {isFan && (
  //                 <Button
  //                   onClick={follow}
  //                   app
  //                   bg={!following ? theme.SECONDARY : ''}
  //                   bordered
  //                   // reverse={!following}
  //                   reverse={true}
  //                   // bg={following ? '#fff' : '#000'}
  //                   text={following ? t('profile.following') : t('common.follow')}
  //                   pad='0 15.5px 0 16.5px'
  //                   gridColSpan={2}
  //                 />
  //               )}
  //               {/* {!isFan && (
  //                 <Button
  //                   text={t(isSubscribed ? 'common.subscribed' : 'common.subscribe')}
  //                   marg='0 0 0 8px'
  //                   icon={isSubscribed && 'doubleCheck'}
  //                   onClick={isSubscribed ? unsubscribe : subscribe}
  //                   app
  //                   bg={theme.SECONDARY}
  //                   pad='0 20.5px 0 21.5px'
  //                   iconSize={22}
  //                 />
  //               )} */}

  //               {/* <Icon type='menu' col='#fff' dimensions={16} marg='0 0 0 15px'/> */}
  //             </Row>
  //           )}
  //         </Row>

  //         <Bio user={user} />

  //         {/* <Sports
  //           user={user}
  //           isCurrentUser={isCurrentUser}
  //         /> */}

  //         <Interactions
  //           user={user}
  //           isCurrentUser={isCurrentUser}
  //           handleGetApp={handleGetApp}
  //           updateOtherUser={updateOtherUser}
  //         />

  //         <Sports
  //           user={user}
  //           isCurrentUser={isCurrentUser}
  //         />

  //         <Interactions
  //           user={user}
  //           isCurrentUser={isCurrentUser}
  //           handleGetApp={handleGetApp}
  //           updateOtherUser={updateOtherUser}
  //           currentUser={currentUser}
  //         />

  //         <SubSettings
  //           visible={subSettingsVisible}
  //           handleClose={() => setSubSettingsVisible(false)}
  //           onUnsubscribe={() => {
  //             updateOtherUser({
  //               ...user,
  //               subscriberCount: user.subscriberCount - 1
  //             })
  //           }}
  //           item={subSettingsVisible && isSubscribed}
  //         />
  //       </Col>
  //     </Col>
  //   )
  // }

  return (
    <Row
      between
      borderBox
      // Positioning context for the P4P Day badge in the wide layout — see below.
      pos="relative"
      wid={isMobile ? '100vw' : '936px'}
      pad={isMobile ? '2rem 1rem' : '2rem'}
      gap={isMobile ? '12px' : '5rem'}
      rowWrap={isMobile}
      center={!isCurrentUser && !isFan}
      bg2={getRoleBgColor(user?.type)}
    >
      {isMobile ? (
        <>
          {/* MOBILE VIEW --------------------- */}
          <Col wid="100%">
            <Row marg="0 0 24px">
              <Avatar user={user} showVerified />

              <Col center marg="0 0 0 16px" wrap>
                <Text h1={!isMobile} h4={isMobile} col={isMobile ? '#fff' : '#000'}>
                  {user.name}
                </Text>

                <Row center start>
                  <Text c1 med col={isMobile ? '#fff' : '#000'}>
                    @{user.username}
                  </Text>

                  {isVerified && (
                    <Row marg="0 0 0 6px" center>
                      <Icon type="verified" col={theme.PURPLE} dimensions={18} />

                      <Text c1 med col="#fff" marg="0 0 0 4px">
                        {t('profile.verifiedAthlete')}
                      </Text>
                    </Row>
                  )}
                </Row>

                <FollowingFollowers
                  user={user}
                  updateOtherUser={updateOtherUser}
                  isCurrentUser={isCurrentUser}
                />
              </Col>

              {isP4PDayTeam && (
                <P4PDayGiftBadge
                  giftColor={currentUser?.p4pDay?.giftColor}
                  badgeNo={currentUser?.p4pDay?.badgeNo}
                  onClick={() => setP4PDayGiftVisible(true)}
                  style={{ marginLeft: 'auto', alignSelf: 'flex-start' }}
                />
              )}
            </Row>
          </Col>
        </>
      ) : (
        <>
          {/* DESKTOP VIEW --------------------- */}
          <Row>
            <Avatar user={user} large showVerified />

            <Col noFlex marg="0 0 0 24px" gap="16px">
              <Col>
                <Text h1 col="#fff">
                  {user.name}
                </Text>

                <Row center start>
                  <Text c1 med col="#fff">
                    @{user.username}
                  </Text>

                  {isVerified && (
                    <Row marg="0 0 0 6px" center>
                      <Icon type="verified" col={theme.PURPLE} dimensions={22} />

                      <Text c1 med marg="0 0 0 4px" col="fff">
                        {t('profile.verifiedAthlete')}
                      </Text>
                    </Row>
                  )}
                </Row>

                <FollowingFollowers user={user} isCurrentUser={isCurrentUser} />
              </Col>

              <Bio user={user} />

              <Sports user={user} isCurrentUser={isCurrentUser} />
            </Col>
          </Row>

          {/*
            Pinned to the header's upper-right corner, per the brief ("to the right of FC Tokyo,
            upper-right corner of the Team Channel header").

            Absolute rather than `margin-left: auto`: the outer header is a space-between row
            whose two children are the avatar/name block and the action buttons, so the inner
            row is content-sized and a margin-auto has no free space to consume — which is why
            the badge rendered next to the name instead of at the right.
          */}
          {isP4PDayTeam && (
            <P4PDayGiftBadge
              giftColor={currentUser?.p4pDay?.giftColor}
              badgeNo={currentUser?.p4pDay?.badgeNo}
              onClick={() => setP4PDayGiftVisible(true)}
              style={{ position: 'absolute', top: '1rem', right: '1rem' }}
            />
          )}
        </>
      )}

      <P4PDayFanGiftModal visible={p4pDayGiftVisible} close={() => setP4PDayGiftVisible(false)} />

      <Interactions
        user={user}
        isCurrentUser={isCurrentUser}
        handleGetApp={handleGetApp}
        following={following}
        follow={follow}
        unfollow={unfollow}
        isSubscribed={isSubscribed}
        subscribe={subscribe}
        hasSubscriptionPlans={hasSubscriptionPlans}
        updateOtherUser={updateOtherUser}
        unsubscribe={unsubscribe}
        // onHandleTriggerFace2Face={handleTriggerFace2Face}
        playedSports={playedSports}
        onHandleShoutout={handleShoutout}
        onShoutoutPosted={onShoutoutPosted}
      />

      <SubSettings
        visible={subSettingsVisible}
        handleClose={() => setSubSettingsVisible(false)}
        onUnsubscribe={() => {
          updateOtherUser({
            ...user,
            subscriberCount: user.subscriberCount - 1
          });

          onHandleClosePaymentAndCTAModals();
        }}
        item={subSettingsVisible && isSubscribed}
      />
    </Row>
  );
};

export default Header;
